import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import SettingsContext from './context';
import { useBaseCurrency } from '../../hooks/useBaseCurrency';
import useBreadcrumbs from '../../views/base/Breadcrumbs/hooks';

import { useUserContext } from '../user';
import { useAnalyticsContext } from '../analytics';

import { useDebouncedEffect } from '../../hooks/useDebouncedEffect';
import { getHolidays } from '../../services/StrategicOverview';

const SettingsContextProvider = ({ children }) => {
  const { userIsLogged, userSession } = useUserContext();
  const { mixPanel: { trackPageEvent } } = useAnalyticsContext();
  const currency = useBaseCurrency();

  const [holidaysList, setHolidaysList] = useState([]);

  const {
    defaultItems: defaultBreadcrumbsItems, breadcrumbsItems, setBreadcrumbsItems,
  } = useBreadcrumbs();

  useDebouncedEffect(() => {
    const init = async () => {
      try {
        const holidays = await getHolidays({ country: userSession.country || 'BR' });

        setHolidaysList(holidays || []);
      } catch (error) {
        // error
      }
    };

    if (userIsLogged()) {
      init();
    }
  }, [userSession.country]);

  useEffect(() => {
    if (userIsLogged()) {
      trackPageEvent(breadcrumbsItems);
    }
  }, [breadcrumbsItems]);

  const value = useMemo(() => ({
    currency,
    holidaysList,
    breadcrumbs: {
      defaultBreadcrumbsItems,
      breadcrumbsItems,
      setBreadcrumbsItems,
    },
  }), [currency, breadcrumbsItems, holidaysList]);

  return (
    <SettingsContext.Provider value={value}>
      { children }
    </SettingsContext.Provider>
  );
};

SettingsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SettingsContextProvider;
